import { render, staticRenderFns } from "./ConfigurationUrlPolicy.vue?vue&type=template&id=a5e3af0a&"
import script from "./ConfigurationUrlPolicy.vue?vue&type=script&lang=js&"
export * from "./ConfigurationUrlPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports